import { render, staticRenderFns } from "./devSituation.vue?vue&type=template&id=4a31efe2&scoped=true&"
import script from "./devSituation.vue?vue&type=script&lang=js&"
export * from "./devSituation.vue?vue&type=script&lang=js&"
import style0 from "./devSituation.vue?vue&type=style&index=0&id=4a31efe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31efe2",
  null
  
)

export default component.exports